import { styled } from '@linaria/react';

export const StyledActions = styled.div`
	display: flex;
	width: 100%;
	max-width: 25rem;
	flex-direction: column;
	margin-right: auto;
	margin-left: auto;
	gap: var(--gap-x4);
`;

export const BottomActions = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	gap: var(--gap-x2);

	& *:first-child,
	& *:last-child {
		cursor: pointer;
		text-decoration: underline;
	}
`;
